import React from 'react';
import { useShowContext } from 'framework/show';
import { ControlledList, DataGridLayout, useListContext } from 'framework/list';
import PublishKpiValueButton from '../buttons/PublishKpiValueButton';
import { EnumField, TextField } from 'framework/ui/field';
import {
  KPI_TYPES_UNIT_OPTIONS,
  KPI_VALUES_UPDATE,
  SERVICE_MANAGEMENT_KPI_VALUE_CREATE_KPI_VALUE,
} from '../../useKPIService';
import UpdateKpiValueButton from '../buttons/UpdateKpiValueButton';

const KPIValueListField = ({ source, dateSource }: { source: string; dateSource: string }) => {
  const { data } = useShowContext();
  const { filter, reloadData = () => {} } = useListContext();
  const kpis = data.getValueBySource(source);
  const effectiveDate = data.getValueBySource(dateSource);
  const kpiStructureId = data.getValueBySource('id');
  const currentFilterValue = filter?.period?.eq;

  return (
    <ControlledList data={{ items: kpis, totalPages: 1, totalElements: kpis?.length }}>
      <DataGridLayout
        customEmptyMessage="No parameters found"
        buttons={[
          <PublishKpiValueButton
            kpiStructureId={kpiStructureId}
            effectiveDate={effectiveDate}
            currentFilterValue={currentFilterValue}
            permissionToCheck={SERVICE_MANAGEMENT_KPI_VALUE_CREATE_KPI_VALUE}
            parenListReload={reloadData}
          />,
          <UpdateKpiValueButton permissionToCheck={KPI_VALUES_UPDATE} parenListReload={reloadData} />,
        ]}
      >
        <TextField label="Name" source="name" width="30%" />
        <TextField label="Value" source="value" width="30%" />
        <EnumField label="Type" source="type" options={KPI_TYPES_UNIT_OPTIONS} />
      </DataGridLayout>
    </ControlledList>
  );
};

export default KPIValueListField;
